import { Component } from "@angular/core";

@Component({
  selector: "app-vittaa-slider-logo",
  templateUrl: "./vittaa-slider-logo.component.html",
  styleUrls: ["./vittaa-slider-logo.component.scss"],
})
export class VittaaSliderLogoComponent {
  logos = [
    { background: "none", svg: "assets/img/vittaa/logo-vittaa-green.svg" },
  ];

  slideConfig = {
    dots: false,
    arrows: true,
  };

  constructor() {}

  ngOnInit() {}
}
